var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1472,
    height: 348,
    viewBox: "0 0 1472 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_1_209)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 736,
    cy: -28.5,
    rx: 232,
    ry: 134.5,
    fill: "url(#paint0_linear_1_209)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_209",
    x: 0,
    y: -667,
    width: 1472,
    height: 1277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 252,
    result: "effect1_foregroundBlur_1_209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_209",
    x1: 495.614,
    y1: -52.4111,
    x2: 968.262,
    y2: -46.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10A9E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBlur);
export default __webpack_public_path__ + "static/media/footer-blur.81819fd8e5b3abdae4a2eacb7b192ace.svg";
export { ForwardRef as ReactComponent };